export default __webpack_public_path__ + "static/media/ic-arrow-consult.eaaa9ae8.svg";